import React from "react";
import cx from "classnames";

import PlaceholderImage from "assets/img/placeholder.png";
import Button from "shared/Button";
import { priceFormatter } from "shared/utility";

import styles from "./SubscriptionUpsellCard.module.scss";

const SubscriptionUpsellCard = ({
  className,
  countryCode,
  currency,
  isAdded,
  isLoading,
  onAdd,
  upsell
}) => {
  const showSubtitle =
    upsell.subtitle && upsell.subtitle !== "Default Title";
  const image =
    upsell.image?.url ||
    upsell.variant?.image?.url ||
    upsell.product?.image?.url ||
    PlaceholderImage;
  const formattedPrice =
    upsell.price?.formatted ||
    priceFormatter({
      price: upsell.price?.amount,
      countryCode,
      currency
    });

  return (
    <article className={cx(styles.card, className)} role="listitem">
      <img className={styles.image} src={image} alt="" loading="lazy" />
      <div className={styles.details}>
        <p className="gkit-p-17 fw-bold mb-1">{upsell.title}</p>
        {showSubtitle && (
          <p className="gkit-p-15 gkit-light mt-0 mb-1">
            {upsell.subtitle}
          </p>
        )}
        <p className="gkit-p-17 mt-0 mb-0">{formattedPrice}</p>
      </div>
      <Button
        className={styles.addButton}
        disabled={isAdded || isLoading}
        isLoading={isLoading}
        onClick={onAdd}
      >
        {isAdded ? "Added" : "Add"}
      </Button>
    </article>
  );
};

export default SubscriptionUpsellCard;
